export default __webpack_public_path__ + "static/media/kangaroo1.9c5b4166.jpg";